import React from 'react'
import { Select, Input, Radio } from 'antd'
import { FormChangeHandler, FormFieldProperties, FormField } from './types'
import { sanitizeValue } from "./lib/apiUtils";

const { TextArea } = Input;

const phoneNumberValidator = (rule:any, value:string, callback:any) => {
  const val = sanitizeValue(value, 'integer') + ''
  if (val.length != 10) {
    callback(new Error('Please enter a 10 digit phone number.'))
  } else {
    callback()
  }
}

const phoneNumberEmailRequired = (props: FormFieldProperties) => {
  return ! ((props.values.emailAddress != null &&
         props.values.emailAddress.length > 0) ||
         (props.values.phoneNumber != null &&
          props.values.phoneNumber.length > 0) ||
          !props.values.followupRequested)
}

const CustomerSurveyFields: FormField[] = [
  {
    label: 'Topic',
    name: 'typeOfRequest',
    formFieldId: 59, // Refers to form field in remote state. Should never change.
    type: 'smallText',
    validationType: 'text',
    rules: (props:FormFieldProperties) => [
      { required: true, message: 'Please select a request type.' }
      ],
    initialValue: (props:FormFieldProperties) => 'Product Recommendation',
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <Select
        // @ts-ignore
        showSearch
        placeholder='Select Request Type'
        optionFilterProp='children'
        // @ts-ignore
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1}
      >
        <Select.Option value={'Product Recommendation'}>
          Product Recommendation
        </Select.Option>
      </Select>
    )
  },
  {
    label: 'Name',
    name: 'name',
    formFieldId: 60, // Refers to form field in remote state. Should never change.
    type: 'smallText',
    rules: (props:FormFieldProperties) => [
      { required: props.values.followupRequested, message: 'Please enter your name.' }
    ],
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <Input
        placeholder='Your Name'
      />
    )
  },
  {
    label: 'Store Location',
    name: 'storeId',
    formFieldId: 61, // Refers to form field in remote state. Should never change.
    type: 'integer',
    rules: (props:FormFieldProperties) => [
      { required: true, message: 'Please select a store.' }
    ],
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <Select
        // @ts-ignore
        disabled={props.stores.length === 0}
        showSearch
        placeholder='Select Store'
        optionFilterProp='children'
        // @ts-ignore
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1}
      >
        {props.stores.constructor === Array && props.stores.filter((a) => !a.disabled).sort((a, b) => {
          if (a.name < b.name) { return -1 }
          if (a.name > b.name) { return 1 }
          return 0
        }).map((store, key:number) => (
          <Select.Option key={key+''} value={store.id}>
            {store.name}
          </Select.Option>
        ))}
      </Select>
    )
  },
  {
    label: 'Item Details',
    name: 'details',
    formFieldId: 62, // Refers to form field in remote state. Should never change.
    type: 'text',
    rules: (props:FormFieldProperties) => [
      { required: true, message: 'Please enter details.' },
      ],
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <TextArea
        rows={4}
        placeholder='Please enter all the item details you have available here. (A UPC is very helpful.)'
      />
    )
  },
  {
    label: 'Do you want us to contact you to discuss your product request?',
    name: 'followupRequested',
    formFieldId: 63, // Refers to form field in remote state. Should never change.
    type: 'boolean',
    initialValue: (props:FormFieldProperties) => false,
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <Radio.Group
        onChange={(e: any) => handleChange('followupRequested', e.target.value)}
      >
        <Radio.Button value={false}>Don't contact me.</Radio.Button>
        <Radio.Button value>Please contact me.</Radio.Button>
      </Radio.Group>
    )
  },
  {
    label: 'Phone Number',
    name: 'phoneNumber',
    formFieldId: 64, // Refers to form field in remote state. Should never change.
    type: 'smallText',
    validationType: 'integer',
    /*rules: (props:FormFieldProperties) => [
      { required: phoneNumberEmailRequired(props), message: 'Please enter a phone number we can contact you at.' },
      { validator: (rule:any, value:string, callback:any) => {
          if (!phoneNumberEmailRequired(props)){
            callback()
          }
          return phoneNumberValidator(rule, value, callback);
      }, message: 'Please enter a 10 digit phone number.'}
      ],
    render: (props:FormFieldProperties) => props.values.followupRequested,
    component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
      <Input
        onChange={(e: any) => handleChange('phoneNumber', e.target.value)}
        placeholder='(000) 123-4567'
      />*/
      rules: (props:FormFieldProperties) => [
        { required: props.values.followupRequested, message: 'Please enter a phone number we can contact you at.' },
        { validator: phoneNumberValidator, message: 'Please enter a 10 digit phone number.'}
        ],
      render: (props:FormFieldProperties) => props.values.followupRequested,
      component: (props:FormFieldProperties, handleChange:FormChangeHandler) => (
        <Input
          placeholder='(000) 123-4567'
        />
    )
  },
  {
    label: 'Email Address',
    name: 'emailAddress',
    formFieldId: 65, // Refers to form field in remote state. Should never change.
    type: 'smallText',
    render: (props: FormFieldProperties) => props.values.followupRequested,
    /*rules: (props: FormFieldProperties) => [
      { required: phoneNumberEmailRequired(props), message: 'Please enter your email address.' }],
    component: (props: FormFieldProperties, handleChange: FormChangeHandler) => (
        <Input 
        onChange={(e: any) => handleChange('emailAddress', e.target.value)}
        placeholder="example@email.com" 
        type="email" />*/
    rules: (props: FormFieldProperties) => [{ required: false, message: 'Please enter your email address.' }],
    component: (props: FormFieldProperties, handleChange: FormChangeHandler) => (
    <Input placeholder="example@email.com" type="email" />
    )
  },
]

export default CustomerSurveyFields
